import { useEffect, useState } from "react";
import { hubConnection } from "../signalr";

export default function LiveEventStream({ deviceId }) {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    // Listen for real-time events
    hubConnection.on("eventLogged", evt => {
      if (evt.deviceId === deviceId) {
        setEvents(prev => [evt, ...prev]);
      }
    });

    // Cleanup
    return () => {
      hubConnection.off("eventLogged");
    };
  }, [deviceId]);

  return (
    <div
      style={{
        background: "#111",
        color: "#0f0",
        padding: 10,
        borderRadius: 6,
        height: 250,
        overflowY: "auto",
        fontFamily: "monospace",
        fontSize: 13,
        marginTop: 10
      }}
    >
      {events.length === 0 && <div>No live events yet…</div>}

      {events.map(e => (
        <div key={e.id} style={{ marginBottom: 6 }}>
          <span style={{ color: "#888" }}>
            [{new Date(e.createdAt).toLocaleTimeString()}]
          </span>{" "}
          <strong>{e.eventType}</strong>
        </div>
      ))}
    </div>
  );
}
